// extracted by mini-css-extract-plugin
export var item = "styles-module--item--37Sz-";
export var header = "styles-module--header--ZVTPh";
export var headerContent = "styles-module--headerContent--1SYfy";
export var icon = "styles-module--icon--1SY17";
export var name = "styles-module--name--2LD3z";
export var id = "styles-module--id--1euUS";
export var service = "styles-module--service--3xHmX";
export var time = "styles-module--time--3wgF8";